import styled from 'react-emotion';
import AulauiIconButton from '@ublend-npm/aulaui-next-web/IconButton';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const IconButton = styled(AulauiIconButton)`
  color: ${colors.white};
  opacity: 70%;
  :hover {
    background-color: ${colors.blackAlpha(0.28)};
  }
  :active {
    background-color: ${colors.blackAlpha(0.08)};
  }
  margin-bottom: 12px;
`;

export const HelpButton = styled(IconButton)`
  color: ${colors.grey8};
`;

export const AvatarContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  margin-bottom: 12px;
`;
